import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Box, Container, Paper, Stack, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { PrimaryButton } from "widgets";
import routes from "constants/routes";
import { tokenUtils } from "utils";

const Unauthorized = ({ variant = "inPlace" }) => {
  const drawerWidth = "14rem";
  const navigate = useNavigate();
  const location = useLocation();

  const loggedIn = tokenUtils.isUserLoggedIn();

  if (!loggedIn) {
    return (
      <Navigate
        to={`${routes.login.root}?redirect=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  return (
    <Box
      sx={{
        minHeight: variant === "standalone" ? "100vh" : "calc(100vh - 64px)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        ...(variant === "inPlace"
          ? { ml: drawerWidth, width: `calc(100% - ${drawerWidth})` }
          : { width: "100%" }),
        py: 6,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 3,
            p: { xs: 3, sm: 4 },
          }}
        >
          <Stack spacing={2.5} alignItems="flex-start">
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: 2,
                display: "grid",
                placeItems: "center",
                bgcolor: "action.hover",
                alignSelf: "center",
              }}
            >
              <LockOutlinedIcon sx={{ fontSize: 48 }} />
            </Box>

            <Box>
              <Typography variant="h5" fontWeight={700} gutterBottom sx={{ textAlign: "center" }}>
                You’re not authorized to view this page
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Your are signed in, but you are not authorized to view this page. If you believe this is a mistake, please contact your
                administrator.
              </Typography>
            </Box>

            <Stack direction="column" spacing={1.5} alignItems="center" width="100%">
              <PrimaryButton
                variant="contained"
                onClick={() => {
                  tokenUtils.logout();
                  navigate(routes.login.root, { replace: true });
                }}
              >
                Logout
              </PrimaryButton>
            </Stack>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default Unauthorized;

